<div class="image-puzzle-preview">
  <div class="image-preview-inner puzzle-elevation-z5" [style.width.px]="tileWidth*columns">
    <div class="image-preview-row" *ngFor="let row of tiles" [class.hidden]="!show">
      <div class="image-preview-column" *ngFor="let i of row">
        <div class="image-preview-tile" [style.height.px]="tileHeight" [style.width.px]="tileWidth"><img src="{{tileImages[i]}}"/></div>
      </div>
    </div>
  </div>

  <ion-text class="image-puzzle-copyright"><div [innerHTML]="copyright" class="ion-text-right"></div></ion-text>
</div>
